import tableTemplate from './reactStatementsTable.html';
import { reactStatementsCols, defaultSortModel } from './statementsDetailColDefs';
import {ReactTableController} from "../reactTableController";
import {statementOptions} from "../../../views/administration/userReports/UserReportDetailDialogController";
import { AccountService } from '../../../services/AccountService';
import {accounts, USER_ACC_REACT, statements} from "../../../services/arsweb/RoutingPaths";
import {REPORT_TYPE} from "../../../components/report/ReportModalController";

export const DETAILVIEW = 'app.statementDetail';

/** @ngInject */
export function reactStatementsTable() {
    return {
        restrict: 'E',
        scope: {
            tableId: '@',
            fractionDigits: '=',
            height: '@',
            selectedKey: '@',
            withSelection: '=',
            parentController: '=',
            selectedAccounts: '=',
            hideColumns: '='
        },
        templateUrl: tableTemplate,
        controller: ReactStatementsTableController,
        controllerAs: 'statementsTableController'
    };
}

/** @ngInject */
export class ReactStatementsTableController extends ReactTableController {

    constructor($scope, userService, arsMainDependencies) {
        
        super($scope, userService, arsMainDependencies, DETAILVIEW, new AccountService(userService), accounts + statements,
            "STATEMENTS", 'statementsTableParams', "statementID", false, statementOptions, defaultSortModel);
        this.isUserReport = false;
        this.refreshAfterReport = true;
        statementOptions.withLastAndUnread = false;
        statementOptions.withDateRange = false;
        this.backendService.service.config.params['id'] = arsMainDependencies.$stateParams.id;
        this.backendService.service.config.params.filter = {};
        this.initGrid(userService);

        const parentOnReport = this.defaultReactGridParams.onReport;
        this.defaultReactGridParams.onReport = (selectedNodes) => {
            this.updateReportTypesForSelection();
            parentOnReport.call(this, selectedNodes);
        };
    }

    initGrid(userService) {

        userService.promise.then(()=> {
            // react account columns
            this.colDefs = reactStatementsCols(this.translate, userService.filterFormatter, this.$scope);
			this.initCols();
            // react gridParameters for account table
            const statementsGridParams = {
                columnDefs: this.colDefs,
                url: this.backendService.service.getServiceUrl(USER_ACC_REACT + statements),
                onCellClicked: (row) => {
                    this.showChildDetailsView(row.data[this.rowNodeID])
                }};

            this.reactGridParams = {...this.defaultReactGridParams, ...statementsGridParams};
        });
    }

    updateReportTypesForSelection() {
        // Remove previous CAMT053 if present
        statementOptions.options = statementOptions.options.filter(opt =>
            opt !== REPORT_TYPE.CAMT053_STATEMENTS
        );
        // Add CAMT053 if flag is true
        if (this.getCamt05xFlag()) {
            statementOptions.options.push(REPORT_TYPE.CAMT053_STATEMENTS);
        }
    }
}
